module.exports = __webpack_public_path__ + "static/media/s_v8_t1.d950ba50.mp3";